import { combineReducers } from 'redux'
import { IMenuItem } from '../../../types/menuItems'
import {
  activeMenuItem,
  sidebarVisible,
  activeSubMenuItem,
  activeDropdownMenuItem,
  openConfirmModal,
  formOpen,
  formDirty
} from './sidebarReducer'


export interface MainState {
  activeMenuItem: IMenuItem
  activeSubMenuItem: IMenuItem
  activeDropdownMenuItem: IMenuItem
  sidebarVisible: boolean
  openConfirmModal: boolean
  formOpen: boolean
  formDirty: boolean
}

const mainApp = combineReducers<MainState>({
  activeMenuItem,
  activeSubMenuItem,
  activeDropdownMenuItem,
  sidebarVisible,
  openConfirmModal,
  formOpen,
  formDirty
})

export default mainApp
